import { brown1, pink1 } from 'assets/stylesheets/base/_colors';
import Generator from './generator';

export default class EnrolmentCurveGenerator extends Generator {
  static _lineChartConfig = {
    yAxis: 0,
    type: 'line',
    dashStyle: null,
    showInLegend: true,
    enableMouseTracking: true,
    customTags: ['enrollment'],
  };

  getEnrollmentSeriesData(objectArray) {
    const forecastedKey = 'forecastEnrollmentMidQuantile';
    const baselinePlanKey = 'origPlanEnrolledCum';
    const currentPlanKey = 'currPlanEnrolledCum';
    const actualPlanKey = 'actualEnrolledCum';

    const enrolmentSeriesData = {
      baselinePlan: this._getSeriesData(objectArray, baselinePlanKey),
      currentPlan: this._getSeriesData(objectArray, currentPlanKey),
      actual: this._getSeriesData(objectArray, actualPlanKey),
      forecast: this._getSeriesData(objectArray, forecastedKey),
    };

    return enrolmentSeriesData;
  }

  getSeries(objectArray) {
    const lineSeriesData = this.getEnrollmentSeriesData(objectArray);
    const plannedSeries = {
      id: 'plannedEnrollment',
      name: 'Enrollment (Current Plan)',
      data: lineSeriesData.currentPlan,
      color: pink1,
      zIndex: 3,
      marker: { enabled: lineSeriesData.currentPlan.length === 1 },
      ...EnrolmentCurveGenerator._lineChartConfig,
    };

    const actualAndForecastedSeries = {
      id: 'actualEnrollment',
      name: 'Enrollment (Actual)',
      data: lineSeriesData.actual,
      color: brown1,
      zIndex: 3,
      marker: { enabled: lineSeriesData.actual.length === 1 },
      ...EnrolmentCurveGenerator._lineChartConfig,
    };

    const enrolmentSeries = [
      // E2R1 Baseline Reactivation
      // baselineSeries,
      plannedSeries,
      actualAndForecastedSeries,
    ];

    return enrolmentSeries;
  }
}
